module.exports = __webpack_public_path__ + "static/media/favourable.39f49b13.svg";